// omeprazole-dosage-calculator.ts
import Alpine from 'alpinejs';
import "../store/email-capture"
import AppAnalytics from '../analytics/AppAnalytics';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('omeprazoleDosageCalculator', function() {
    return {
      // Presets
      concPresets: [5, 10, 20, 40],
      liquidConcMode: 'preset',      // 'preset' | 'custom'
      liquidConcPreset: 20,          // mg/mL default
      liquidConcMgPerMl: 100,        // used when custom

      pasteConcMode: 'preset',
      pasteConcPreset: 370,
      pasteConcMgPerMl: 370,

      weight: 0,
      weightUnit: 'kg',
      purpose: 'treatment',
      formulation: 'liquid',
      capsuleStrengthMg: 200,

      // Outputs
      totalMg: 0,
      resultText: '',
      details: '',

      // Helpers
      toKg(val: number, unit: string) { return unit === 'lb' ? (val / 2.20462) : val; },
      dosageRateMgPerKg() { return this.purpose === 'treatment' ? 1.5 : 0.5; },
      round(n: number, places = 2) { const f = Math.pow(10, places); return Math.round(n * f) / f; },
      effectiveLiquidConc() { return this.liquidConcMode === 'preset' ? this.liquidConcPreset : this.liquidConcMgPerMl; },
      effectivePasteConc() { return this.pasteConcMode === 'preset' ? this.pasteConcPreset : this.pasteConcMgPerMl; },

      calculate() {
        this.$store.emailCap.cancel();

        if (!this.weight || this.weight <= 0) {
          this.resultText = '';
          this.details = '';
          return;
        }

        const kg = this.toKg(this.weight, this.weightUnit);
        const mgNeeded = kg * this.dosageRateMgPerKg();
        this.totalMg = mgNeeded;

        if (this.formulation === 'liquid') {
          const conc = this.effectiveLiquidConc();
          if (!conc || conc <= 0) { this.resultText = ''; this.details = ''; return; }
          const mL = mgNeeded / conc;
          this.resultText = `${this.round(mL, 2)} mL`;
          this.details = `${this.round(mgNeeded, 1)} mg total @ ${conc} mg/mL`;

        } else if (this.formulation === 'paste') {
          const conc = this.effectivePasteConc();
          if (!conc || conc <= 0) { this.resultText = ''; this.details = ''; return; }
          const mL = mgNeeded / conc;
          this.resultText = `${this.round(mL, 2)} mL of paste/gel`;
          this.details = `${this.round(mgNeeded, 1)} mg total @ ${conc} mg/mL`;

        } else {
          if (!this.capsuleStrengthMg || this.capsuleStrengthMg <= 0) { this.resultText = ''; this.details = ''; return; }
          const exactCaps = mgNeeded / this.capsuleStrengthMg;
          const wholeCaps = Math.ceil(exactCaps * 2) / 2;
          this.resultText = `${this.round(exactCaps, 2)} caps (≈ ${this.round(wholeCaps, 1)} if rounding to ½ cap)`;
          this.details = `${this.round(mgNeeded, 1)} mg total @ ${this.capsuleStrengthMg} mg per cap/tab`;
        }

        if (this.resultText) this.$store.emailCap.onResult();

        AppAnalytics.getPlausible()?.trackEvent('omeprazole_dosage_result', {
          props: {
            ageGroup: this.ageGroup,
            kg,
            purpose: this.purpose,
            formulation: this.formulation,
          }
        });

      }
    };
  });
});

Alpine.start();

